export const formatDistanceLabel = (distanceMeter: number): string =>
  distanceMeter >= 1000
    ? `${Math.round(distanceMeter / 1000)}km`
    : `${Math.round(distanceMeter)}m`;
